import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AccessDeniedState {
  open: boolean;
  resourceName: string;
}

const initialState: AccessDeniedState = {
  open: false,
  resourceName: "My Profile",
};

const accessDeniedSlice = createSlice({
  name: "accessDenied",
  initialState,
  reducers: {
    openAccessDeniedDialog: (state, action: PayloadAction<string | undefined>) => {
      state.open = true;
      state.resourceName = action.payload ?? "My Profile";
    },
    closeAccessDeniedDialog: (state) => {
      state.open = false;
    },
  },
});

export const { openAccessDeniedDialog, closeAccessDeniedDialog } = accessDeniedSlice.actions;

export default accessDeniedSlice.reducer;
